import { EntityMultiSelect, Form } from '@domain-group/suit-theme'

import useProviders from '@hooks/useProviders'

import useBulkCreateBrandProviderModal from '../../hooks/useBulkCreateBrandProviderModal'

type SelectProvidersProps = {
  bulkCreateBrandProviderPayload: ReturnType<typeof useBulkCreateBrandProviderModal>,
}

const SelectProviders = (props: SelectProvidersProps) => {
  const { bulkCreateBrandProviderPayload } = props

  const {
    callbacks: {
      setSelectedEntityIds,
      setState,
    },
    debouncedString,
    providers,
    selectedEntityIds,
    string,
  } = bulkCreateBrandProviderPayload

  const providersPayload = useProviders({
    filters: { string: debouncedString },
    performHttpRequests: debouncedString.length > 1,
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredProviders,
    filteredProvidersCount,
    loading,
  } = providersPayload

  const filteredProviderIds = debouncedString.length > 1 ? filteredProviders.map(provider => provider.id) : []

  return (
    <>
      <Form.Field label="Search Providers">
        <input onChange={e => setState({ string: e.target.value })} value={string} />
      </Form.Field>

      {/*
       // @ts-expect-error TS2741 */}
      <EntityMultiSelect
        boxProps={{ marginTop: 'large' }}
        callbacks={{
          loadMore,
          setSelectedIds: setSelectedEntityIds,
        }}
        canLoadMore={canLoadMore}
        entities={providers}
        entityCount={filteredProvidersCount}
        filteredEntityIds={filteredProviderIds}
        loading={loading}
        height={500}
        selectedIds={selectedEntityIds}
      />
    </>
  )
}

export default SelectProviders
